/*
 *
 * ZingerCardDetailS reducer
 *
 */

import { fromJS } from 'immutable';
import {
  DEFAULT_ACTION,
} from './constants';

const initialState = fromJS({});

function zingerCardDetailSReducer(state = initialState, action) {
  switch (action.type) {
    case DEFAULT_ACTION:
      return state;
    default:
      return state;
  }
}

export default zingerCardDetailSReducer;



// WEBPACK FOOTER //
// client/containers/_ZingerCardDetails/reducer.js